import React, { useState, useEffect } from "react";
import {
  Button,
  Divider,
  Grid,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { useTheme } from "@material-ui/core/styles";
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import VisibilityIcon from '@material-ui/icons/Visibility';
import SettingsIcon from '@material-ui/icons/Settings';
import { useParams, useHistory } from 'react-router-dom';
import Notifications from "../../components/Notifications";
import { Form } from "../../components/useForm";
import Input from "../../components/controls/Input";
import { Dialog as DialogComponent } from "../../components/Dialog";
import { getDispatchPlansDetails, setDispatchOrderStatus, getInvoicesForDispatchMaterial, saveSAPData, getInvoice, updateDispatchedQuantity, getSAPDataForDispatchPlan, updateDispatchPlanWithSAP } from "../../services/dispatchPlan";
import { getCurrentUser } from "../../services/userService";
import { STATUS, USER_TYPES } from "../../constants/index";
import ActionButton from "../../components/controls/ActionButton";
import UpdateTruckDetails from "./UpdateTruckDetails";
import DispatchMaterialDetails from "./DispatchMaterialDetails";
import { getSpecificConsignee } from "../../services/consigneeService";
const useStyles = makeStyles((theme) => ({
  pageContent: {
    // margin: theme.spacing(3),
    padding: theme.spacing(1),
  },
  toolbar: theme.mixins.toolbar,

  textCenter: {
    textAlign: "center",
  },
  btn: {
    color: "#4DE019",
    borderColor: "#4DE019",
    "&:hover": {
      background: "#4DE019",
      color: "#fff",
    },
  },
  btnReject: {
    color: "#F43333",
    borderColor: "#F43333",
    "&:hover": {
      background: "#F43333",
      color: "#fff",
    },
  },
  table: {
    // minWidth: 650,
    // display: "block",
    // overflowX: "auto",
  },
  container: {
    display: "block",
    maxWidth: "85vw",
    overflowX: "auto",
    marginRight: "auto",
    marginLeft: "auto",
    padding: "10px",
    margin: "10px",
  },
  textLight: {
    fontWeight: "normal",
    fontSize: "14px",
    lineHeight: "16px",
    color: "#323232",
    opacity: "0.75",
  },
  textDark: {
    fontWeight: "500",
    fontSize: "15px",
    lineHeight: "18px",
    color: "#323232",
    opacity: "0.99",
  },
  comment: {
    fontWeight: "500",
    fontSize: "13px",
    lineHeight: "16px",
    color: "#5A1515",
    opacity: "0.75",
  },
}));

const OrderView = () => {
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [dispatchDetails, setDispatchDetails] = useState([]);
  const [currentUser, setCurrentUser] = useState();
  const [dispatchOrder, setDispatchOrder] = useState({
    total_amount: 0,
    total_materials: 0,
    total_quantity: null,
    total_rate: null,
    discount: null,
    gst: null,
    creator_type: null,
    status: null,
    reasonForRejection: '',
    purchaseOrderId: null,
    consignee_id: null,
  });
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  const [invoices, setInvoices] = useState([]);
  const [invoiceOpen, setInvoiceOpen] = useState(false);
  const [truckDetailForm, setTruckDetailForm] = useState(false);
  const [materialDisplay, setMaterialDisplay] = useState(false);
  const [reasonForRejectionText, setReasonForRejectionText] = useState("");
  const [reasonForRejection, setReasonForRejection] = useState("");
  const [dispatchedQuantityInputed, setDispatchedQuantityInputed] = useState({})
  const [dispatchMaterialId, setDispatchMaterialId] = useState()
  const [dispatchMaterial, setDispatchMaterial] = useState()
  const [consignee, setConsignee] = useState()
  const [sapData, setSapData] = useState({});
  const [sapFetched, setSapFetched] = useState(false);
  const [invoicePopupOpen, setInvoicePopupOpen] = useState(false);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  //Newly added 

  // const [status  , setStatus] = useState(1);
  let { id } = useParams();

  const [comment, setComment] = useState(null);

  const theme = useTheme();
  //   const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleTruckDetailFormPopUpOpen = (dm) => {
    setDispatchMaterialId(dm.dispatch_material_id);
    setDispatchMaterial(dm);
    setTruckDetailForm(true);
  };

  const handleTruckDetailFormPopUpClose = () => {
    setTruckDetailForm(false);
  };

  const handleMaterialDisplayPopUpOpen = async dm => {
    setDispatchMaterial(dm);
    const consigneeId = dm?.consignee_id || dispatchOrder?.consignee_id;
    if (consigneeId) {
      try {
        const response = await getSpecificConsignee(consigneeId);
        if (response?.data?.data && response.data.data.length > 0) {
          setConsignee(response.data.data[0]);
        } else {
          setConsignee(null);
        }
      } catch (error) {
        console.error("Error fetching consignee details:", error);
        setConsignee(null);
      }
    } else {
      setConsignee(null);
    }
    setMaterialDisplay(true);
  };

  const handleMaterialDisplayPopUpClose = () => {
    setMaterialDisplay(false);
  };

  const handleInvoiceClickOpen = async (dispatchMateriaId) => {
    let invoices = await getInvoicesForDispatchMaterial(dispatchMateriaId);
    setInvoices(invoices);
    setInvoiceOpen(true);
  };

  const handleInvoiceClose = () => {
    setInvoiceOpen(false);
  };
  //new added method to open popup 
  const handleInvoiceCountClick = async (row) => {
    try {
      const invoices = await getInvoicesForDispatchMaterial(row.dispatch_material_id);
      console.log('Fetched invoices:', invoices); // Debug log
      setSelectedInvoices(invoices);
      setInvoicePopupOpen(true);
    } catch (error) {
      console.error("Error fetching invoices:", error);
      setNotify({
        isOpen: true,
        message: "Error fetching invoice details",
        type: "error",
      });
    }
  };
  const handleInvoicePopupClose = () => {
    setInvoicePopupOpen(false);
    setSelectedInvoices([]);
  };
  // const fetchSAPData = async () => {
  //   if (!dispatchOrder.ref_no || sapFetched) return;

  //   console.log('🚀 Fetching SAP data for ref_no:', dispatchOrder.ref_no);

  //   try {
  //     const response = await getSAPDataForDispatchPlan(dispatchOrder.ref_no);
  //     console.log('📦 SAP API Response:', response);

  //     if (response && response.status === 1 && response.data) {
  //       // Extract the actual data
  //       let sapDataContent = response.data;
  //       if (sapDataContent.data) {
  //         sapDataContent = sapDataContent.data;
  //       }

  //       console.log('✅ Extracted SAP Data:', sapDataContent);

  //       // PRODUCTION FIX: Use ONLY the first invoice's items
  //       // This ensures no duplicate/incorrect data is shown
  //       const primaryInvoice = sapDataContent.invoices?.[0];
  //       const items = primaryInvoice?.items || [];

  //       console.log('📦 Using primary invoice:', primaryInvoice?.invoiceNo);
  //       console.log('📦 Items from primary invoice:', items);

  //       // Prepare data for saving - only from primary invoice
  //       const itemsToSave = items.map(item => ({
  //         salesItem: item.salesItem,
  //         quantity: item.quantity,
  //         salesOrder: item.salesOrder,
  //         invoiceNo: primaryInvoice.invoiceNo
  //       }));

  //       console.log('📦 Items to save:', itemsToSave);

  //       // Prepare data for saving
  //       const sapDataToSave = {
  //         invoice_no: primaryInvoice.invoiceNo, // Use single invoice number, not comma-separated
  //         items: itemsToSave
  //       };

  //       console.log('💾 Saving to DB:', sapDataToSave);

  //       // Save to database
  //       try {
  //         const saveResult = await saveSAPData(id, sapDataToSave);
  //         console.log('💾 Save result:', saveResult);

  //         if (saveResult && saveResult.status === 1) {
  //           console.log('✅ SAP data saved to database');
  //           // Refresh the dispatch details to get the saved SAP data
  //           await fetchDispatchDetails();
  //         } else {
  //           console.error('❌ Failed to save SAP data:', saveResult?.message);
  //         }
  //       } catch (saveError) {
  //         console.error('❌ Error saving to DB:', saveError);
  //       }

  //       // Store in state for display
  //       setSapData({
  //         invoice_no: primaryInvoice.invoiceNo,
  //         sales_order_no: sapDataContent.sales_order_no,
  //         dispatched_quantity: items.reduce((sum, item) => sum + item.quantity, 0),
  //         items: items,
  //         invoices: [primaryInvoice] // Only store the primary invoice
  //       });
  //     }
  //   } catch (error) {
  //     console.error('Error in fetchSAPData:', error);
  //   }

  //   setSapFetched(true);
  // };

  const fetchSAPData = async () => {
    if (!dispatchOrder.ref_no || sapFetched) return;

    console.log('🚀 Fetching SAP data for ref_no:', dispatchOrder.ref_no);

    try {
      const response = await getSAPDataForDispatchPlan(dispatchOrder.ref_no);
      console.log('📦 SAP API Response:', response);

      if (response && response.status === 1 && response.data) {
        let sapDataContent = response.data;
        if (sapDataContent.data) {
          sapDataContent = sapDataContent.data;
        }

        console.log('✅ Extracted SAP Data:', sapDataContent);

        // Get truck details from the response
        const truckNo = sapDataContent.truckNo || null;
        const transporterName = sapDataContent.transporterName || null;
        const driverMobile = sapDataContent.driverMobile || null;

        // Get all items from all invoices
        const allItems = [];

        if (sapDataContent.invoices && Array.isArray(sapDataContent.invoices)) {
          sapDataContent.invoices.forEach(invoice => {
            if (invoice.items && Array.isArray(invoice.items)) {
              invoice.items.forEach(item => {
                allItems.push({
                  salesItem: item.salesItem,
                  quantity: item.quantity,
                  salesOrder: item.salesOrder,
                  invoiceNo: invoice.invoiceNo,
                  invoiceDate: invoice.invoiceDate,
                  materialName: item.description || item.material,
                  material: item.material
                });
              });
            }
          });
        }

        console.log('📦 Items to save:', allItems);
        console.log('🚛 SAP Truck Details:', { truckNo, transporterName, driverMobile });

        // Prepare data for saving
        const sapDataToSave = {
          invoice_no: sapDataContent.invoice_no,
          items: allItems,
          truckNo: truckNo,
          transporterName: transporterName,
          driverMobile: driverMobile
        };

        console.log('💾 Saving to DB:', sapDataToSave);

        // Save to database
        try {
          const saveResult = await saveSAPData(id, sapDataToSave);
          console.log('💾 Save result:', saveResult);

          if (saveResult && saveResult.status === 1) {
            console.log('✅ SAP data saved to database');
            await fetchDispatchDetails();
          } else {
            console.error('❌ Failed to save SAP data:', saveResult?.message);
          }
        } catch (saveError) {
          console.error('❌ Error saving to DB:', saveError);
        }

        // Store in state for display
        setSapData({
          invoice_no: sapDataContent.invoice_no,
          sales_order_no: sapDataContent.sales_order_no,
          dispatched_quantity: allItems.reduce((sum, item) => sum + item.quantity, 0),
          items: allItems,
          invoices: sapDataContent.invoices || [],
          truckNo: truckNo,
          transporterName: transporterName,
          driverMobile: driverMobile
        });
      }
    } catch (error) {
      console.error('Error in fetchSAPData:', error);
    }

    setSapFetched(true);
  };
  const handleSubmitApproveDO = () => {
    let funcSetDispatchOrderStatus = async () => {
      let reasonForRejectionText = "";
      let status = 3;
      let data = await setDispatchOrderStatus({ reasonForRejectionText, id, status });
      let d = data.data;
      if (d.status == 1) {
        setReasonForRejectionText("");
        setReasonForRejection("");
        // setStatus(2);
        setDispatchOrder({ ...dispatchOrder, status: 3 });
        setNotify({
          isOpen: true,
          message: "Order Approved",
          type: "success",
        });
      }
    };
    funcSetDispatchOrderStatus();
  }

  const handleRejectDOMessage = (e) => {
    // let reasonForRejectionText = e.target.value;
    setReasonForRejectionText(e.target.value);
  }


  const handleSubmitRejectDOMessage = () => {
    // let reason_for_rejection_text = state.reason_for_rejection_text;
    if (reasonForRejectionText == "") {
      alert("Please enter reason for rejection.");
    } else {

      let funcSetDispatchOrderStatus = async () => {
        // let reasonForRejectionText = state.reasonForRejectionText;
        let status = 2;
        let data = await setDispatchOrderStatus({ reasonForRejectionText, id, status });
        let d = data.data;
        if (d.status == 1) {
          setOpen(false);
          setReasonForRejection(reasonForRejectionText);
          setReasonForRejectionText(reasonForRejectionText);
          // setStatus(2);
          setDispatchOrder({ ...dispatchOrder, status: 2, reasonForRejection: reasonForRejectionText });
          setNotify({
            isOpen: true,
            message: "Order Rejected",
            type: "error",
          });
        }
      };
      funcSetDispatchOrderStatus();

    }
  }

  const fetchConsignee = async () => {
    let response = await getSpecificConsignee(dispatchOrder?.consignee_id);
    setConsignee(response?.data?.data[0]);
  }

  const fetchDispatchDetails = async () => {
    let dispatchedPlanDetails = await getDispatchPlansDetails(id);

    // Create the dispatchOrder object with ref_no included
    const newDispatchOrder = {
      total_amount: dispatchedPlanDetails[0]?.total_amount,
      total_materials: dispatchedPlanDetails[0]?.total_materials,
      total_quantity: dispatchedPlanDetails[0]?.total_quantity,
      total_rate: dispatchedPlanDetails[0]?.total_rate,
      discount: dispatchedPlanDetails[0]?.discount,
      gst: dispatchedPlanDetails[0]?.gst,
      creator_type: dispatchedPlanDetails[0]?.creator_type,
      status: dispatchedPlanDetails[0]?.status,
      reasonForRejection: dispatchedPlanDetails[0]?.reason_for_rejection,
      remarks: dispatchedPlanDetails[0]?.remarks,
      material_option: dispatchedPlanDetails[0]?.material_option,
      purchaseOrderId: dispatchedPlanDetails[0]?.purchase_order_id,
      consignee_id: dispatchedPlanDetails[0]?.consignee_id,
      ref_no: dispatchedPlanDetails[0]?.ref_no  // ADD THIS LINE
    };
    console.log('Setting dispatchOrder with material_option:', newDispatchOrder.material_option);
    console.log('Setting dispatchOrder with ref_no:', newDispatchOrder.ref_no);
    setDispatchOrder(newDispatchOrder);
    setDispatchDetails(dispatchedPlanDetails);
  };
  // useEffect(async () => {
  //   await fetchDispatchDetails();
  //   let user = await getCurrentUser();
  //   setCurrentUser(user.data.body)
  // }, [])

  // useEffect(() => {
  //   fetchConsignee();
  // }, [dispatchOrder?.consignee_id])

  // REPLACE THIS EXISTING useEffect:
  // useEffect(async () => {
  //   await fetchDispatchDetails();
  //   let user = await getCurrentUser();
  //   setCurrentUser(user.data.body)
  // }, []);

  // // Add this useEffect to fetch SAP data after dispatch details load
  // useEffect(() => {
  //   if (dispatchOrder.ref_no && !sapFetched) {
  //     fetchSAPData();
  //   }
  // }, [dispatchOrder.ref_no, sapFetched]);

  // WITH THESE UPDATED useEffects:

  // First useEffect - Fetch dispatch details and user




  useEffect(() => {
    const loadData = async () => {
      await fetchDispatchDetails();
      let user = await getCurrentUser();
      setCurrentUser(user.data.body);
    };
    loadData();
  }, []);
  // Add this useEffect to log when sapData changes and force re-render
  useEffect(() => {
    console.log('🔄 sapData UPDATED:', sapData);
    console.log('Invoice from SAP:', sapData?.invoice_no);
    console.log('Quantity from SAP:', sapData?.dispatched_quantity);
  }, [sapData]);
  // Second useEffect - Fetch SAP data after dispatchOrder is ready
  useEffect(() => {
    console.log('Checking SAP fetch for ref_no:', dispatchOrder.ref_no, 'sapFetched:', sapFetched);

    // Only fetch if we have a ref_no and haven't fetched yet
    if (dispatchOrder.ref_no && !sapFetched) {
      console.log('Triggering SAP fetch for:', dispatchOrder.ref_no);
      fetchSAPData();
    }
  }, [dispatchOrder.ref_no, sapFetched]);
  return (
    <main className={classes.pageContent}>
      <div className={classes.toolbar} />

      <div style={{ marginBottom: "20px" }}>
        <Grid container justifyContent="space-between">
          <Grid>
            <Breadcrumbs aria-label="breadcrumb">
              <Link color="textPrimary" href={`/dispatch-plans/${dispatchOrder.purchaseOrderId}`} >
                All Dispatch Plans
              </Link>
              <Link color="inherit">
                Dispatch Plan Details
              </Link>
            </Breadcrumbs>
          </Grid>
          <Grid>
            {
              (currentUser && currentUser.user_type !== USER_TYPES.SALES_PERSON && currentUser.user_type != dispatchOrder.creator_type && (dispatchOrder.status == 1)) ?
                <div>
                  <Button
                    className={classes.btnReject}
                    variant="outlined"
                    style={{ marginRight: "5px" }}
                    onClick={handleClickOpen}
                  >
                    Reject
                  </Button>
                  <Button className={classes.btn} variant="outlined" onClick={(e) => handleSubmitApproveDO()}>
                    Approve Plan
                  </Button>
                </div>
                : (
                  currentUser && currentUser.user_type == dispatchOrder.creator_type && (dispatchOrder.status == STATUS.REJECTED || dispatchOrder.status === STATUS.PENDING)
                ) ? <div>
                  <Button className={classes.btnReject}
                    variant="outlined"
                    onClick={() => history.push('/edit-dispatch-plan/' + dispatchOrder.purchaseOrderId + "/" + id)}
                  >
                    Edit
                  </Button>
                </div> : ""
            }
          </Grid>
        </Grid>
      </div>

      {/* comment popup */}
      <Dialog
        // fullScreen={fullScreen}
        // maxWidth="md"
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle className={classes.textCenter}>
          {"Add Comments"}
        </DialogTitle>
        <Divider light></Divider>
        <DialogContent className={classes.textCenter}>
          <div
            style={{ minHeight: "300px", minWidth: "500px", marginTop: "20px" }}
          >
            <Grid container justifyContent="center" spacing={2}>
              <Grid item xs={12}>
                <TextField
                  placeholder="Type here..."
                  multiline
                  label="Add Comments for Rejection"
                  rows={8}
                  cols={700}
                  fullWidth
                  onChange={(e) => handleRejectDOMessage(e)}
                  variant="outlined"
                ></TextField>
              </Grid>
              <Grid item xs={12} style={{ marginTop: "90px" }}>
                <Button
                  color="primary"
                  variant="contained"
                  style={{ width: "200px" }}
                  // onClick={submitComment}
                  onClick={(e) => handleSubmitRejectDOMessage(e)}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </div>
        </DialogContent>
      </Dialog>


      {/* invoice popup */}
      <Dialog
        open={invoiceOpen}
        onClose={handleInvoiceClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          {`Invoice (${invoices.length})`}
        </DialogTitle>
        <Divider light></Divider>
        <DialogContent className={classes.textCenter}>
          <div
            style={{ minHeight: "300px", minWidth: "500px", marginTop: "20px" }}
          >
            <div style={{ marginBottom: "25px" }}>
              <Paper className={classes.container}>
                <Table className={classes.table} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">Invoice No.</TableCell>
                      <TableCell align="center">Invoice</TableCell>
                      <TableCell align="center">SO_No.</TableCell>
                      <TableCell align="center">INV_DT</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {invoices.length === 0 ?
                      <TableRow><TableCell colSpan={4}> No invoices available ! </TableCell></TableRow>
                      : invoices.map((row) => (
                        <TableRow key={row.FILE_NM}>
                          <TableCell align="center">{row.INV_NO}</TableCell>
                          <TableCell component="th" scope="row" align="center">
                            {row.FILE_NM}&nbsp;&nbsp;
                            <Link
                              onClick={async () => {
                                try {

                                  let invoiceData = await getInvoice(row.FILE_NM);
                                  // console.log(invoiceData)
                                  const blob = new Blob([invoiceData], { type: 'application/pdf' })
                                  let a = document.createElement('a');
                                  a.href = window.URL.createObjectURL(blob);
                                  a.download = `${row.FILE_NM || 'Invoice'}`
                                  a.click();
                                } catch (err) {
                                  console.log("🚀 ~ file: DispatchPlanDetails.js ~ line 385 ~ onClick={ ~ err", err?.response.data);
                                  setNotify({
                                    isOpen: true,
                                    message: `${err.response.data.message ||
                                      "Invoice not Found ! Please contact Admin !"
                                      }`,
                                    type: "error"
                                  });
                                }
                                // console.info("I'm a button.");
                              }}
                              style={{ 'cursor': 'pointer' }}
                            >
                              <AttachFileIcon
                                fontSize="small"
                              />
                            </Link>
                          </TableCell>
                          <TableCell align="center">{row.SO_NO}</TableCell>
                          <TableCell align="center">{row.INV_DT}</TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </Paper>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      {dispatchOrder.remarks &&
        <div style={{ marginBottom: "25px" }}>
          <div className={classes.textDark} style={{ marginBottom: "10px" }}>
            Remarks
          </div>
          <Paper style={{ padding: "10px" }}>
            <p className={classes.comment}>
              {dispatchOrder.remarks}
            </p>
          </Paper>
        </div>
      }
      <div style={{ marginBottom: "25px" }}>
        <div className={classes.textDark} style={{ marginBottom: "10px" }}>
          Material Option
        </div>
        <Paper style={{ padding: "10px", backgroundColor: '#f5f5f5' }}>
          <p className={classes.comment} style={{
            color: dispatchOrder.material_option ? '#1976d2' : '#999',
            fontWeight: dispatchOrder.material_option ? 'bold' : 'normal'
          }}>
            {dispatchOrder.material_option || "-"}
          </p>
        </Paper>
      </div>
      {dispatchOrder.status == STATUS.REJECTED && dispatchOrder.reasonForRejection &&
        <div style={{ marginBottom: "25px" }}>
          <div className={classes.textDark} style={{ marginBottom: "10px" }}>
            Comment For Rejection
          </div>
          <Paper style={{ padding: "10px" }}>
            <p className={classes.comment}>
              {/* {Lorem ipsum dolor sit amet consectetur adipisicing elit. Nostrum in
              distinctio repellat totam temporibus repudiandae sapiente, natus
              dignissimos blanditiis assumenda quas, harum nihil magni non.
              Impedit in natus quis nihil.} */}
              {dispatchOrder.reasonForRejection}
            </p>
          </Paper>
        </div>
      }
      <div style={{ marginBottom: "25px" }}>
        <Paper
          className={classes.container}
          key={`sap-table-${sapFetched}-${sapData?.invoice_no || 'no-sap'}`}
        >
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Total Material</TableCell>
                <TableCell align="center">Total Quantity (MT)</TableCell>
                <TableCell align="center">Total Rate (with GST) (&#8377;)</TableCell>
                <TableCell align="center">Discount (&#8377;)</TableCell>
                <TableCell align="center">GST (&#8377;)</TableCell>
                <TableCell align="center">Final Amount (with GST) (&#8377;)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                <TableRow>
                  <TableCell component="th" scope="row" align="center">
                    {dispatchOrder.total_materials}
                  </TableCell>
                  <TableCell align="center">{dispatchOrder.total_quantity}</TableCell>
                  <TableCell align="center">{dispatchOrder.total_rate}</TableCell>
                  <TableCell align="center">{dispatchOrder.discount}</TableCell>
                  <TableCell align="center">{dispatchOrder.gst}</TableCell>
                  <TableCell align="center">{dispatchOrder.total_amount}</TableCell>
                </TableRow>
              }
            </TableBody>
          </Table>
        </Paper>
      </div>

      <div className={classes.table}>
        <Paper className={classes.container}>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Line Item No.</TableCell>
                <TableCell align="center">Material Code</TableCell>
                <TableCell align="center">Material Name</TableCell>
                <TableCell align="center">Quantity (MT)</TableCell>
                {(dispatchDetails[0]?.dependent_type_id) &&
                  <TableCell align="center">Special Length (m)</TableCell>
                }
                <TableCell align="center">Rate	(&#8377;)</TableCell>
                <TableCell align="center">Total (&#8377;)</TableCell>
                <TableCell align="center">Consignee</TableCell>
                <TableCell align="center">Location</TableCell>
                <TableCell align="center">Invoice</TableCell>
                <TableCell align="center">Dispatched Quantity (MT)</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dispatchDetails.map((row) => (
                <TableRow key={row.dispatch_material_id || row.id}>
                  <TableCell align="center">{row.line_item_no}</TableCell>
                  <TableCell component="th" scope="row" align="center">
                    {row.material_code}
                  </TableCell>
                  <TableCell align="center">{row.material_name}</TableCell>
                  <TableCell align="center">{row.quantity}</TableCell>
                  {dispatchDetails[0]?.dependent_type_id &&
                    <TableCell align="center">{row.special_length}</TableCell>}
                  <TableCell align="center">{row.rate}</TableCell>
                  <TableCell align="center">{row.amount}</TableCell>
                  <TableCell align="center">{row.consignee_name}</TableCell>
                  <TableCell align="center">{row.dispatch_to}</TableCell>
                  <TableCell align="center">
                    {row.sap_invoice_count && row.sap_invoice_count > 0 ? (
                      <span
                        onClick={() => {
                          console.log('=== INVOICE CLICK DEBUG ===');
                          console.log('row.sap_invoice_details:', row.sap_invoice_details);
                          console.log('row.sap_invoice_count:', row.sap_invoice_count);
                          console.log('row.sap_quantity:', row.sap_quantity);

                          if (row.sap_invoice_details) {
                            try {
                              const invoiceDetails = JSON.parse(row.sap_invoice_details);
                              console.log('Parsed invoice details:', invoiceDetails);

                              const formattedInvoices = invoiceDetails.map(inv => ({
                                INV_NO: inv.invoiceNo,
                                INV_DT: inv.invoiceDate || 'N/A',
                                SO_NO: inv.salesOrder,
                                SO_QTY: inv.quantity,
                                MATERIAL_NAME: inv.materialName || row.material_name || 'N/A',
                                FILE_NM: `${inv.invoiceNo}.PDF`
                              }));

                              console.log('Formatted invoices:', formattedInvoices);
                              setSelectedInvoices(formattedInvoices);
                              setInvoicePopupOpen(true);
                            } catch (e) {
                              console.error('Parse error:', e);
                              handleInvoiceCountClick(row);
                            }
                          } else {
                            console.log('No sap_invoice_details, calling handleInvoiceCountClick');
                            handleInvoiceCountClick(row);
                          }
                        }}
                        style={{
                          cursor: 'pointer',
                          color: '#1976d2',
                          fontWeight: 'bold',
                          textDecoration: 'underline',
                          backgroundColor: '#e3f2fd',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          display: 'inline-block'
                        }}
                      >
                        {row.sap_invoice_count} Invoice{row.sap_invoice_count !== 1 ? 's' : ''}
                      </span>
                    ) : (
                      <span style={{
                        color: '#999',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        display: 'inline-block',
                        backgroundColor: '#f5f5f5'
                      }}>
                        0 Invoices
                      </span>
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {
                      currentUser && currentUser.user_type === "admin" ?
                        <Form onSubmit={async e => {
                          e.preventDefault();
                          try {
                            const response = await updateDispatchedQuantity({
                              dispatched_quantity: dispatchedQuantityInputed[row.dispatch_material_id]
                            }, row.dispatch_material_id)
                            setNotify({
                              isOpen: true,
                              message: `${response.data.message || "Dispatched Quantity Updated Successfully !"}`,
                              type: "success"
                            });
                          } catch (err) {
                            setNotify({
                              isOpen: true,
                              message: `${err.response?.data?.message || "Dispatched Quantity could not be updated !"}`,
                              type: "error"
                            });
                          }
                          fetchDispatchDetails();
                          setDispatchedQuantityInputed({ [row.dispatch_material_id]: null })
                        }}>
                          <Input
                            label="Dispatched"
                            type="Number"
                            value={dispatchedQuantityInputed[row.dispatch_material_id] !== undefined ?
                              dispatchedQuantityInputed[row.dispatch_material_id] :
                              row.sap_quantity || row.dispatched_quantity}
                            variant="outlined"
                            disabled={row.lineItemStatus === STATUS.COMPLETED || row.status !== STATUS.IN_PROGRESS}
                            size="small"
                            onChange={e => setDispatchedQuantityInputed({ [row.dispatch_material_id]: e.target.value })}
                          />
                          {(row.status === STATUS.IN_PROGRESS) &&
                            <Button type='submit'>Save</Button>
                          }
                        </Form>
                        :
                        // Display SAP quantity if available, else manual dispatched quantity or 0
                        <span style={{
                          color: row.sap_quantity ? '#ff9800' : 'inherit',
                          fontWeight: row.sap_quantity ? 'bold' : 'normal',
                          backgroundColor: row.sap_quantity ? '#fff3e0' : 'transparent',
                          padding: row.sap_quantity ? '4px 8px' : '0',
                          borderRadius: '4px',
                          display: 'inline-block'
                        }}>
                          {row.sap_quantity
                            ? Number(row.sap_quantity).toFixed(2)
                            : (row.dispatched_quantity !== null && row.dispatched_quantity !== undefined ? row.dispatched_quantity : 0)} MT
                        </span>
                    }
                  </TableCell>
                  <TableCell>
                    <ActionButton color="primary">
                      <VisibilityIcon
                        onClick={(e) => handleMaterialDisplayPopUpOpen(row)}
                        fontSize="small"
                      />
                    </ActionButton>
                    {(dispatchOrder.status === STATUS.IN_PROGRESS) && (currentUser?.user_type === USER_TYPES.ADMIN || currentUser?.user_type === USER_TYPES.SALES_PERSON) && <ActionButton color="primary">
                      <SettingsIcon
                        onClick={e => handleTruckDetailFormPopUpOpen(row)}
                        fontSize="small"
                      />
                    </ActionButton>}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </div>
      <DialogComponent
        heading="Update Vehicle Details"
        handleClose={handleTruckDetailFormPopUpClose}
        open={truckDetailForm}
        width="md"
      >
        <UpdateTruckDetails
          dispatchMaterialId={dispatchMaterialId}
          dispatchMaterial={dispatchMaterial}
          dispatchPlanId={id}
          handleClose={handleTruckDetailFormPopUpClose}
          setNotify={setNotify}
          updateDPDetails={fetchDispatchDetails}
        />
      </DialogComponent>
      <DialogComponent
        heading="Material Details"
        handleClose={handleMaterialDisplayPopUpClose}
        open={materialDisplay}
        width="md"
      >
        <DispatchMaterialDetails
          dispatchMaterial={dispatchMaterial}
          dispatchPlanId={id}
          consignee={consignee}
          sapData={sapData}
        // handleClose={handleMaterialDisplayPopUpClose}
        // setNotify={setNotify}
        // updateDPList={funcGetDispatchOrderList}
        />

      </DialogComponent>
      {/* Invoice Details Popup */}
      {invoicePopupOpen && (
        <Dialog
          open={invoicePopupOpen}
          onClose={() => {
            console.log('Closing popup');
            setInvoicePopupOpen(false);
            setSelectedInvoices([]);
          }}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            Invoice Details
            <IconButton
              onClick={() => {
                console.log('Close button clicked');
                setInvoicePopupOpen(false);
                setSelectedInvoices([]);
              }}
              style={{ position: 'absolute', right: '8px', top: '8px' }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <div style={{ minHeight: "200px", padding: "20px" }}>
              {selectedInvoices.length === 0 ? (
                <div style={{ textAlign: 'center' }}>
                  No invoice details available
                </div>
              ) : (
                <Table>
                  <TableHead>
                    <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                      <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '14px' }}>Material Name</TableCell>
                      <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '14px' }}>Invoice No.</TableCell>
                      <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '14px' }}>Invoice Date</TableCell>
                      <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '14px' }}>SO No.</TableCell>
                      <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '14px' }}>Quantity (MT)</TableCell>
                      {/* <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '14px' }}>Invoice File</TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedInvoices.map((invoice, idx) => (
                      <TableRow key={idx}>
                        <TableCell align="center" style={{ fontWeight: 'bold', color: '#1976d2' }}>
                          {invoice.MATERIAL_NAME || 'N/A'}
                        </TableCell>
                        <TableCell align="center">{invoice.INV_NO}</TableCell>
                        <TableCell align="center">
                          {invoice.INV_DT && invoice.INV_DT !== 'N/A' && invoice.INV_DT.match(/^\d{4}-\d{2}-\d{2}$/)
                            ? (() => {
                              const [year, month, day] = invoice.INV_DT.split('-');
                              return `${day}-${month}-${year}`;
                            })()
                            : invoice.INV_DT || 'N/A'
                          }
                        </TableCell>
                        <TableCell align="center">{invoice.SO_NO}</TableCell>
                        <TableCell align="center">{invoice.SO_QTY}</TableCell>
                        {/* <TableCell align="center">
                    <Link
                      onClick={async () => {
                        try {
                          let invoiceData = await getInvoice(invoice.FILE_NM);
                          const blob = new Blob([invoiceData], { type: 'application/pdf' });
                          let a = document.createElement('a');
                          a.href = window.URL.createObjectURL(blob);
                          a.download = invoice.FILE_NM || 'Invoice.pdf';
                          a.click();
                        } catch (err) {
                          setNotify({
                            isOpen: true,
                            message: err.response?.data?.message || "Invoice not Found!",
                            type: "error"
                          });
                        }
                      }}
                      style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}
                    >
                      <AttachFileIcon fontSize="small" /> {invoice.FILE_NM}
                    </Link>
                  </TableCell> */}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </div>
          </DialogContent>
        </Dialog>
      )}   <Notifications notify={notify} setNotify={setNotify} />
    </main>
  );
};

export default OrderView;
